export declare function Node(_astNode: any): any;
